export function invalidTokenCheckAndHandler(code: string) {
  if (code === 'IAM_FAILED') {
    window.vue.$router.push({
      name: 'result',
      query: {
        result: 'IAM_FAILED',
      },
    })
    return true
  }
  return false
}

export function imageInvalidTokenCheckAndHandler(code: string) {
  if (code === 'IAM_FAILED') {
    window.vue.$router.push({
      name: 'ImageResult',
      query: {
        result: 'IAM_FAILED',
      },
    })
    return true
  }
  return false
}

export function imageInvalidTokenCheckAndHandlerV2(code: string) {
  if (code === 'IAM_FAILED') {
    window.vue.$router.push({
      name: 'ImageResultV2',
      query: {
        result: 'IAM_FAILED',
      },
    })
    return true
  }
  return false
}
